import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface InformationCircleProps extends IconProps {
  color?: TIconColor;
  design?: 'outline' | 'filled';
}

const InformationCircle = ({
  size,
  variant,
  className,
  color = 'amber',
  design = 'filled'
}: InformationCircleProps) => {
  const isOutline = design === 'outline';

  return isOutline ? (
    <svg
      className={cn(iconVariant({ size, variant, iconColor: color, className }))}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16">
      <path
        d="M7.5 7.5L7.52766 7.48617C7.90974 7.29513 8.33994 7.64023 8.23634 8.05465L7.76366 9.94535C7.66006 10.3598 8.09026 10.7049 8.47234 10.5138L8.5 10.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM8 5.5H8.005V5.505H8V5.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      className={cn(iconVariant({ size, variant, iconColor: color, className }))}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM7.30416 7.03897C8.06832 6.65689 8.92873 7.34709 8.72152 8.17593L8.24884 10.0666L8.2765 10.0528C8.52349 9.9293 8.82383 10.0294 8.94732 10.2764C9.07082 10.5234 8.97071 10.8237 8.72372 10.9472L8.69606 10.9611C7.9319 11.3431 7.07149 10.6529 7.2787 9.82409L7.75138 7.93339L7.72372 7.94722C7.47673 8.07072 7.17639 7.97061 7.0529 7.72362C6.9294 7.47663 7.02951 7.17629 7.2765 7.0528L7.30416 7.03897ZM8 6C8.27614 6 8.5 5.77614 8.5 5.5C8.5 5.22386 8.27614 5 8 5C7.72386 5 7.5 5.22386 7.5 5.5C7.5 5.77614 7.72386 6 8 6Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InformationCircle;
